import { render, staticRenderFns } from "./CopyFeedUrl.vue?vue&type=template&id=0f50a740&"
import script from "./CopyFeedUrl.vue?vue&type=script&lang=js&"
export * from "./CopyFeedUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports